import { Grid } from "@mui/material";
import { Save as SaveIcon, Print as PrintIcon } from '@mui/icons-material'
import React, { useEffect, useState } from "react";
import WSButton from "../../../Components/Button/WSButton";
import WSTextField from "../../../Components/TextBox/WSTextBox";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { callAPI, Method, updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";

export const Category: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const [loadingSaveAndNew, setLoadingSaveAndNew] = useState(false);
  const [loading, setLoading] = useState(false);

  const params = useParams();
  const id = params?.id;

  const { showMessage } = useSnackbar();
  const navigate = useNavigate();

  useEffect(() => {
    updateMainHeader("Category");
  });

  breadCrumbsStore.updateBreadCrumbs([
    { "Category List": "/category/list" },
    { [!id ? "Add Category" : "Update Category"]: "/category/create" },
  ]);

  useEffect(() => {
    if (id) {
      const fetchData = async () => {
        try {
          const response = await callAPI(
            `Vyapar/Category/${id}`,
            Method.GET
          );
          if (response && response.data) {
            const categoryData = response.data;
            setValue("name", categoryData.categoryName);
          }
        } catch (error) {
          console.error("Failed to fetch category data:", error);
        }
      };
      fetchData();
    }
  }, [id, setValue]);

  const handleCancelClick = () => {
    navigate("/category/list");
  };

  const handleData = async (data: any) => {
    try {
      setLoading(true);

      const request = {
        CategoryName: data.name,
      };

      let response;

      if (id) {
        response = await callAPI(
          `Vyapar/Category/${id}`,
          Method.PUT,
          request
        );
      } else {
        response = await callAPI(
          "Vyapar/Category",
          Method.POST,
          request
        );
      }

      if (response) {
        showMessage(
          response?.message,
          response.success === true ? "success" : "error"
        );

        if (response.success === true) {
          navigate("/category/list");
        }
      }
    } catch (error) {
      console.error("Failed to save user:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDataSaveAndNew = async (data: any) => {
    try {
      setLoadingSaveAndNew(true);

      const request = {
        CategoryName: data.name,
      };

      let response;

      if (id) {
        response = await callAPI(
          `Vyapar/Category/${id}`,
          Method.PUT,
          request
        );
      } else {
        response = await callAPI(
          "Vyapar/Category",
          Method.POST,
          request
        );
      }


      if (response) {
        showMessage(
          response?.message,
          response.success === true ? "success" : "error"
        );

        if (response.success === true) {
          reset();
        }
      }
    } catch (error) {
      console.error("Failed to save user:", error);
    } finally {
      setLoadingSaveAndNew(false);
    }
  };

  return (
    <>
      <Grid p={3}>
        <form onSubmit={handleSubmit(handleData)}>
          <Grid
            sx={{
              padding: 4,
              backgroundColor: "#fff",
              borderRadius: 2,
              border: "1px solid lightgrey",
              marginTop: 3,
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <WSTextField
                  label={"Category Name"}
                  {...register("name")}
                  id="name"
                  name="name"
                  control={control}
                  rules={{ required: true }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
            <Grid item>
              <WSButton
                id="cancelBtn"
                variant="outlined"
                color="error"
                size="small"
                label="Cancel"
                onClick={handleCancelClick}
              />
            </Grid>
            <Grid item>
              <WSButton
                id="saveAndPrintBtn"
                variant="contained"
                color="secondary"
                size="small"
                startIcon={<PrintIcon />}
                label="Save & New"
                onClick={handleSubmit(handleDataSaveAndNew)}
                loading={loadingSaveAndNew}
              />
            </Grid>

            <Grid item>
              <WSButton
                id="saveBtn"
                variant="contained"
                color="primary"
                size="small"
                label="Save"
                type="submit"
                startIcon={<SaveIcon />}
                onClick={handleSubmit(handleData)}
                loading={loading}
              />
            </Grid>
          </Grid>
        </form>
      </Grid>
    </>
  );
});